import store from "@/store";

export default class FiltersUtils {
	static hasAnyFilters(): boolean {
		const filterProvider = store.getters.getFilterProvider();
		const currentFilters = filterProvider?.getFilterKeySelection();

		return !!currentFilters && currentFilters.length > 0;
	}
}